// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import theme from '../../styled-components/dark';
import { withOpacity } from '../../styled-components/dark/helpers';

const LINE_HEIGHT = 3.2;
const LINE_HEIGHT_PADDING = 0.2;

const LineWrapper = styled.div`
  width: 100%;
  height: ${LINE_HEIGHT}em;
  padding: 0 1em 0 0.5em;

  border-radius: inherit;
  box-shadow: inherit;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  & svg {
    height: ${LINE_HEIGHT / 2}em;
    width: ${LINE_HEIGHT / 2}em;
  }

  cursor: pointer;
`;

const IconsWithLabel = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${LINE_HEIGHT_PADDING}em 0 ${LINE_HEIGHT_PADDING}em 0;

  height: 100%;
  width: 100%;

  ${({ $border }) =>
    $border
      ? css`
          border-top: 1px solid ${withOpacity(theme.SearchResults.color, '0c')};
        `
      : undefined}
`;

const IconsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-right: 0.7em;

  > * {
    &:not(:last-child) {
      margin-right: 0.4em;
    }
  }
`;

const Label = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;

  color: ${theme.ListItem.Label.color};
`;

export type PropsType = {
  label: string;
  icons?: Array<unknown>; // Array of Component (Icons)
  className?: string;
  border?: boolean;
};

const SearchCategoryRowSearchResult = ({ icons, label, className, border = false }: PropsType) => {
  return (
    <LineWrapper className={className}>
      <IconsWithLabel $border={border}>
        <IconsWrapper>{icons}</IconsWrapper>
        <Label>{label}</Label>
      </IconsWithLabel>
    </LineWrapper>
  );
};

export default SearchCategoryRowSearchResult;
